module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/excel-5077c23d08d859caed6c4150c0599fa0.svg";